/*
 * Totkind — cart drawer: Preview + Edit design cho dong ca nhan hoa (06/10, ke thua lb-custom-cart.js cua .co).
 * - Preview: hop xem anh /tkc/v/<ma>.jpg lon.
 * - Edit design: lay lai bo gia tri cu (GET /tkc/don/<ma>.json) -> dung LAI form san pham (window.TKC, che 'sua')
 *   -> Save = dang ky ma MOI (cho may chu ghi xong) -> /cart/change.js thay thuoc tinh NGAY TREN DONG DO
 *   (giu quantity + thuoc tinh _ khac) -> ve lai drawer bang sections + su kien cart:update (itemCount bat buoc).
 * File ES MODULE (import tinh o dau, nap bang type="module"): Shopify minify file KHONG co import tinh doi import() thanh require() -> ReferenceError (06/10).
 * Drawer la <dialog> o top layer -> hop cua minh cung phai la <dialog> mo bang showModal() moi noi len tren.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  if (window.__tkCart) return;
  window.__tkCart = 1;
  var API = 'https://api.totkind.com/tkc';

  function el(t, cls, txt) { var e = document.createElement(t); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function hop(cls, nhan) {
    var d = el('dialog', 'tkc-hop ' + cls); d.setAttribute('aria-label', nhan);
    var dong = el('button', 'tkc-hop__dong'); dong.type = 'button'; dong.setAttribute('aria-label', 'Close'); dong.innerHTML = '&times;';
    d.appendChild(dong);
    var xong = function () { if (d.open) d.close(); };
    dong.addEventListener('click', xong);
    d.addEventListener('click', function (e) { if (e.target === d) xong(); });
    d.addEventListener('close', function () { setTimeout(function () { d.remove(); }, 0); });
    /* Esc chi dong hop nay, khong de lan ra drawer (drawer nghe keydown tren document) */
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') e.stopPropagation(); });
    document.body.appendChild(d);
    return d;
  }

  /* ---------------------------------------------------------------- Preview */
  function moXem(url) {
    var d = hop('tkc-hop--xem', 'Your personalized preview');
    d.appendChild(el('p', 'tkc-hop__tde', 'Your personalized preview'));
    d.appendChild(el('p', 'tkc-hop__phu', 'This is exactly how your ornament will be printed.'));
    var khung = el('div', 'tkc-hop__anh'); var img = el('img', 'tkc-hop__cv'); img.alt = 'Your personalized preview'; img.src = url;
    khung.appendChild(img); d.appendChild(khung);
    d.showModal();
  }

  /* ---------------------------------------------------------------- ve lai gio */
  function sectionIds() {
    var s = [];
    document.querySelectorAll('cart-items-component[data-section-id],cart-icon-component[data-section-id],cart-drawer-component[data-section-id]')
      .forEach(function (e) { if (s.indexOf(e.dataset.sectionId) < 0) s.push(e.dataset.sectionId); });
    return s;
  }
  /* Horizon ban moi (Totkind) nghe StandardEvents.cartLinesUpdate cua @shopify/events (KHONG con 'cart:update' nhu .co):
     phat CartLinesUpdateEvent kem promise, resolve bang sections -> cart-items-component tu morph drawer. */
  function baoGioDoi(cart, sections) {
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : undefined;
    if (n !== undefined) { try { sessionStorage.setItem('cart-count', JSON.stringify({ value: n, timestamp: Date.now() })); } catch (e) {} }
    var cu = function () {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'tkc-edit', data: { source: 'tkc-edit', itemCount: n, sections: sections || {} } };
      document.dispatchEvent(ev);
    };
    try {
      var E = CartLinesUpdateEvent, hua = E.createPromise();
      document.dispatchEvent(new E({ action: 'update', context: 'cart', lines: (cart.items || []).map(function (i) { return { id: i.key, quantity: i.quantity }; }), promise: hua.promise }));
      hua.resolve({ cart: E.createCartFromAjaxResponse(cart), detail: { sections: sections || undefined, items: cart.items, itemCount: n, source: 'tkc-edit', didError: false } });
    } catch (e) { try { console.warn('[tkc] cartLinesUpdate', e); } catch (x) {} cu(); }
  }
  /* lich su ca nhan hoa theo san pham (cung khoa voi tk-custom.js): ban sua moi nhat thanh ban de goi y */
  function ghiLichSu(handle, gt) {
    try {
      var a = JSON.parse(localStorage.getItem('tkc-ls') || '[]'); if (!Array.isArray(a)) a = [];
      a = a.filter(function (x) { return x && x.h !== handle; });
      a.push({ h: handle, gt: gt, t: Date.now() });
      localStorage.setItem('tkc-ls', JSON.stringify(a.slice(-12)));
    } catch (e) {}
  }

  /* ---------------------------------------------------------------- Edit design */
  function moSua(nut) {
    var key = nut.getAttribute('data-key'), ma = nut.getAttribute('data-ma'), handle = nut.getAttribute('data-handle');
    var d = hop('tkc-sua', 'Edit your design');
    d.appendChild(el('p', 'tkc-hop__tde', 'Edit your design'));
    d.appendChild(el('p', 'tkc-hop__phu', nut.getAttribute('data-title') || ''));
    var goc = el('div', 'tkc tkc-sua__goc'); goc.hidden = true; d.appendChild(goc);
    var cho = el('p', 'tkc-sua__cho', 'Loading your design…'); d.appendChild(cho);
    var loi = el('p', 'tkc-sua__loi'); loi.setAttribute('role', 'alert'); d.appendChild(loi);
    var chan = el('div', 'tkc-sua__chan');
    var luu = el('button', 'tkc-hop__mua', 'Save changes'); luu.type = 'button'; luu.disabled = true;
    var huy = el('button', 'tkc-hoi__khong', 'Cancel'); huy.type = 'button';
    chan.appendChild(luu); chan.appendChild(huy); d.appendChild(chan);
    huy.addEventListener('click', function () { d.close(); });
    d.showModal();

    var inst = null;
    fetch(API + '/don/' + encodeURIComponent(ma) + '.json', { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('We couldn’t load this design. Please remove it and personalize again.'); return r.json(); })
      .then(function (don) {
        if (!window.TKC) throw new Error('Please refresh the page and try again.');
        inst = window.TKC(goc, {
          che: 'sua', api: API, handle: don.handle || handle, gt: don.gt || {},
          sanSang: function () {
            cho.remove(); luu.disabled = false;
            /* 08/10 user (iPhone): keo xuong o vung lua chon -> iOS nay (bounce) keo theo anh xem thu -> khoang trang giua tieu de va anh.
               Mobile: dua anh xem thu RA NGOAI vung cuon (nam co dinh giua tieu de va lua chon); desktop giu luoi 2 cot. */
            if (matchMedia('(max-width:749px)').matches) { var xem = goc.querySelector('.tkc-xem--sua'); if (xem) goc.parentNode.insertBefore(xem, goc); }
          },
          loi: function () { cho.textContent = ''; loi.textContent = 'We couldn’t load this design. Please refresh and try again.'; },
        });
      })
      .catch(function (e) { cho.textContent = ''; loi.textContent = e.message; });

    luu.addEventListener('click', function () {
      if (!inst || !inst.kiem()) return;
      loi.textContent = '';
      luu.disabled = true; luu.textContent = 'Saving…';
      var moi = inst.maMoi();
      inst.dangKy(moi)
        .then(function () { return fetch('/cart.js?_tkc=' + Date.now(), { cache: 'no-store' }).then(function (r) { return r.json(); }); })
        .then(function (gio) {
          var dong = (gio.items || []).filter(function (it) { return it.key === key; })[0];
          if (!dong) throw new Error('Could not find this item in your cart. Please refresh and try again.');
          /* /cart/change THAY TOAN BO thuoc tinh: giu cac thuoc tinh _ an khac (tru link file in cu), dung lai phan hien tu form */
          var props = {};
          /* 07/10: thuoc tinh tkc deu co "_" -> bo HET thuoc tinh cu cua dong (ten o co the doi theo dieu kien), dung lai tu form */
          inst.thuocTinh(moi).forEach(function (p) { props[p[0]] = p[1]; });
          return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: dong.quantity, properties: props, sections: sectionIds().join(','), sections_url: window.location.pathname }),
          }).then(function (r) { return r.json(); });
        })
        .then(function (data) {
          if (!data || data.status) throw new Error((data && (data.description || data.message)) || 'Could not update your cart.');
          ghiLichSu(handle, JSON.parse(JSON.stringify(inst.gt())));
          baoGioDoi(data, data.sections);
          d.close();
        })
        .catch(function (e) {
          loi.textContent = (e && e.message) || 'Something went wrong. Please try again.';
          luu.disabled = false; luu.textContent = 'Save changes';
        });
    });
  }

  /* Uy quyen tren document: drawer bi ve lai lien tuc */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    var x = t.closest('[data-tkc-xem]');
    if (x) { e.preventDefault(); moXem(x.getAttribute('data-tkc-xem')); return; }
    var s = t.closest('[data-tkc-sua]');
    if (s) { e.preventDefault(); moSua(s); }
  });
})();
